// import { useState } from "react";
import { useLocation, Link as RouterLink, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  Avatar,
  Box,
  Drawer,
  IconButton,
  Link,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import _get from 'lodash/get';

import IconDashboard from '../../assets/icons/IconDashboard';
import IconAgent from '../../assets/icons/IconAgent';
import IconJobs from '../../assets/icons/IconJobs';
import IconSetting from '../../assets/icons/IconSetting';
import IconWorkflow from '../../assets/icons/IconWorkflow';
import IconLogoVertical from '../../assets/icons/IconLogoVertical';
import IconLogout from '../../assets/icons/IconLogout';

import { logout } from '../../services/auth';
import { logout as logoutAction } from '../../routes/Login/state/AuthSlice';

import './Sidebar.scss';

const menuItem = [
  {
    name: 'Dashboard',
    icon: <IconDashboard width={20} height={20} />,
    path: '/dashboard',
  },
  {
    name: 'Activities',
    icon: <IconJobs width={20} height={20} />,
    path: '/jobs',
    children: [
      {
        name: 'View Jobs',
        path: '/jobs/view',
      },
      {
        name: 'Create Job',
        path: '/jobs/create',
      },
      {
        name: 'Edit Job',
        path: '/jobs/edit',
      },
    ],
  },
  {
    name: 'Agents',
    icon: <IconAgent width={20} height={20} />,
    path: '/agents',
    children: [
      {
        name: 'View Agents',
        path: '/agents/view',
      },
    ],
  },
  {
    name: 'Workflows',
    icon: <IconWorkflow width={20} height={20} />,
    path: '/workflows',
    children: [
      {
        name: 'View Workflows',
        path: '/workflows/view',
      },
    ],
  },
  {
    name: 'Settings',
    icon: <IconSetting width={20} height={20} />,
    path: '/settings',
    children: [
      {
        name: 'Merchants',
        path: '/settings/merchants',
        children: [
          { name: 'View', path: '/settings/merchants/view' },
          { name: 'Edit', path: '/settings/merchants/edit' },
          { name: 'Create', path: '/settings/merchants/create' },
        ],
      },
      {
        name: 'Users',
        path: '/settings/users',
        children: [
          { name: 'View', path: '/settings/users/view' },
          { name: 'Edit', path: '/settings/users/edit' },
          { name: 'Create', path: '/settings/users/create' },
        ],
      },
    ],
  },
];

const Sidebar = ({ open, onClose }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = useSelector((state) => state?.auth?.user?.refresh);
  const loggedInUserId = useSelector((state) => _get(state, 'auth.user.user', ''));
  const loggedInUserName = useSelector((state) => _get(state, 'auth.user.full_name', ''));

  // const [selectedItem, setSelectedItem] = useState('/dashboard');

  // const handleMenuClick = (event, path) => {
  //   setSelectedItem(path);
  // };

  const handleLogout = async () => {
    const response = await logout({ refresh: token });

    if (response.success) {
      dispatch(logoutAction());
    } else {
      console.error(response.message);
    }
  };

  return (
    <>
      <Drawer
        className='sidebar'
        variant={isMobile ? 'temporary' : 'permanent'}
        anchor='left'
        open={open}
        onClose={onClose}
      >
        <Box className='sidebar-inner' role='presentation' textAlign={'center'}>
          <Box
            className='sidebar-logo'
            py={1.5}
            px={1.5}
            borderBottom={1}
            mb={1.5}
            display={'flex'}
            alignItems={'center'}
            justifyContent={'center'}
          >
            <Link component={RouterLink} to='/dashboard' underline='none'>
              <IconLogoVertical width={64} height={59} />
            </Link>
          </Box>

          <List disablePadding className='sidebar-menu'>
            {menuItem.map((menu) => (
              <ListItem key={menu.path} disablePadding>
                <ListItemButton
                  // component={Link}
                  component={RouterLink}
                  to={menu.path}
                  // selected={selectedItem === menu.path}
                  selected={location.pathname.startsWith(menu.path)}
                  // onClick={(event) => handleMenuClick(event, menu.path)}
                >
                  <ListItemIcon>{menu.icon}</ListItemIcon>
                  <ListItemText primary={menu.name} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>

          <Box p={1.5} display={'flex'} alignItems={'center'} flexDirection={'column'} gap={1.5}>
            <Box className='sidebar-profile' textAlign={'center'}>
              <IconButton onClick={() => navigate(`/profile/${loggedInUserId}`)}>
                <Avatar
                  variant='circular'
                  sx={{ cursor: 'pointer', backgroundColor: 'primary.main', fontSize: 16 }}
                >
                  {loggedInUserName
                    ? loggedInUserName
                        .split(' ')
                        .map((word) => word.charAt(0).toUpperCase())
                        .join('')
                    : '-'}
                </Avatar>
              </IconButton>
            </Box>

            <Box className='sidebar-logout'>
              <IconButton onClick={handleLogout} color='inherit' className='btn-logout'>
                <IconLogout width={40} height={40} />
              </IconButton>
            </Box>
          </Box>
        </Box>
      </Drawer>
    </>
  );
};

export default Sidebar;
